import axios from "axios";
import apiURI from "../Api";

export default class BusinessPartnerService {
  async postRegisterBusinessPartner(
    referee,
    username,
    email,
    documentNumber,
    fname,
    lname,
    password,
    currency,
    language,
    transactionID,
    country,
    internationalCode,
    localCode,
    phoneNumber,
    latitude,
    longitude,
    paymentMethod = 1,
    transferbankReceipt = null
  ) {
    const businesspartnerData = {
      documentNumber: null,
      email: email,
      firstname: fname,
      password: password,
      surname: lname,
      language: language,
      country: country,
      internationalCode: internationalCode,
      localCode: localCode,
      phoneNumber: phoneNumber,
      originRegister: JSON.parse(localStorage.getItem("__extraconomy_ismobile__"))
        ? "MOBILE"
        : "WEB",
    };

    if (username !== null && username !== undefined) {
      businesspartnerData.username = username;
    }

    const registerBusinessPartner = {
      transferbankReceipt: transferbankReceipt,
      currency: currency,
      businesspartner: businesspartnerData,
      latitude: typeof latitude === "string" ? parseFloat(latitude) : latitude,
      longitude: typeof longitude === "string" ? parseFloat(longitude) : longitude,
      paymentGateway: {
        id: 1,
      },
      paymentMethod: {
        id: paymentMethod,
      },
      paymenttransactionID: transactionID,
      plan: {
        id: 1,
      },
      referee: {
        username: referee,
      },
    };

    const response = await axios.post(
      `${apiURI}/businesspartner/register`,
      registerBusinessPartner
    );
    return response.data;
  }

  async upgrade(token, username, transactionID) {
    const bodyJson = {
      paymentGateway: { id: 1 },
      paymentMethod: { id: 1 },
      paymenttransactionID: transactionID,
      plan: { id: 1 },
      username: username,
    };

    const response = await axios({
      method: "post",
      url: `${apiURI}/businesspartner/upgrade`,
      data: bodyJson,
      headers: { Authorization: "Bearer " + token },
    });

    return response.data;
  }
}
